import { render } from "./AdminCreateGoal.vue?vue&type=template&id=7465ed48&scoped=true"
import script from "./AdminCreateGoal.vue?vue&type=script&lang=js"
export * from "./AdminCreateGoal.vue?vue&type=script&lang=js"

import "./AdminCreateGoal.vue?vue&type=style&index=0&id=7465ed48&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7465ed48"]])

export default __exports__